import KeyMirror from 'keymirror'

const OrderTypes = KeyMirror({
	GET_LIST_ORDERS: null,
	CONFIRM_ORDER: null,
	CREATE_ORDER_MANUAL: null,
})

export default OrderTypes
